import { useMemo } from 'react';
import chunk from 'lodash/chunk';
import isEmpty from 'lodash/isEmpty';

const initialFields = ['first_name', 'last_name', 'address'];

const useSortFields = (missingFields = [], requiredFields = initialFields) => {
  const fields = useMemo(() => {
    if (missingFields && !isEmpty(missingFields)) {
      const sortedFields = missingFields.sort((nameA, nameB) => {
        // First priority: first_name should always be first
        if (nameA === 'first_name') {
          return -1;
        }
        if (nameB === 'first_name') {
          return 1;
        }

        // Second priority: last_name should be second
        if (nameA === 'last_name') {
          return -1;
        }
        if (nameB === 'last_name') {
          return 1;
        }

        // Third priority: birth/date fields should go after postal_code, city, country
        if (nameA.includes('birth') || nameA.includes('date')) {
          return 1;
        }
        if (nameB.includes('birth') || nameB.includes('date')) {
          return -1;
        }

        // For other fields, maintain original order
        return 0;
      });
      const filteredArray = sortedFields.filter(item => item !== 'signature');

      const allFields = [...requiredFields, ...filteredArray];
      // eslint-disable-next-line
      const uniqFields = [...new Set(allFields)];

      return uniqFields;
    }
    // eslint-disable-next-line
  }, [missingFields.length, requiredFields.length]);

  return { fields, chunkedFields: chunk(fields, 2) || [] };
};

export default useSortFields;
